import { usePathname } from "next/navigation";

function pathToRegex(path: string) {
  // Converte un percorso con variabili in una regex
  const regexString = path.replace(/:[a-zA-Z_][a-zA-Z0-9_]*/g, "([^/]+)");
  return new RegExp(`^${regexString}$`);
}

export default function useMatch(
  path: string | { path: string; end: boolean },
) {
  const pathname = usePathname();

  if (typeof path === "string") {
    const regex = pathToRegex(path);
    return regex.test(pathname);
  }
  const regex = pathToRegex(path.path);
  if (path.end) {
    return regex.test(pathname) && regex.exec(pathname)?.[0] === pathname;
  }
  return pathname?.startsWith(path.path);
}
